import { z } from 'zod';
import { DataGridViewType } from '@/features/DataGridTypeSwitcher';
import { filtersValidator } from '@/features/filters';
import type { ColumnsConfig } from '@/entities/columnsConfig';
import {
  columnsWidthStateValidator,
  DateScale,
  Lifetime,
  serializedDateRangeValueObjectValidator,
  sortingValidator,
} from '@/shared/types';

export enum ValueType {
  absolute = 'absolute',
  percent = 'percent',
}

const highlightValidator = z.object({
  levels: z.number(),
  valueType: z.nativeEnum(ValueType),
});

export type Highlight = z.infer<typeof highlightValidator>;

export const dataConfigValidator = z.object({
  dateScale: z.nativeEnum(DateScale),
  dateRange: serializedDateRangeValueObjectValidator,
  lifetime: z.nativeEnum(Lifetime),
  probabilisticAttribution: z.boolean(),
  filters: filtersValidator,
  dimensions: z.array(z.string()),
  metric: z.string(),
  highlight: highlightValidator,
  dataGridViewType: z.nativeEnum(DataGridViewType),
  columnsWidth: columnsWidthStateValidator,
  sorting: sortingValidator,
  rowHeight: z.number(),
});

export type DataConfig = z.infer<typeof dataConfigValidator>;

export interface Meta {
  defaultColumns: {
    dimensions: string[];
    metric: string;
  };
  config: ColumnsConfig;
  dimensions: string[];
  metrics: string[];
}

type DataRow = Record<string, string | number>;

export interface DataResponse {
  rows: DataRow[];
  columns: string[];
  hasNextPage: boolean;
}

export interface TreeDataResponse {
  rows: DataRow[];
  columns: string[];
}
